import ChannelTypeStore from './channelTypeStore';
import ContactTypeStore from './contactTypeStore';
import MessageTypeStore from './messageTypeStore';
import SmsDeliveryStatusStore from './smsDeliveryStatusStore';
import PushNotificationTokenStore from './pushNotificationTokenStore';
import EmailStore from './emailStore';
import PhoneNumberStore from './phoneNumberStore';
import ContactStore from './contactStore';
import AutoReplyStore from './autoReplyStore';
import ChannelStore from './channelStore';
import ErrorLogStore from './errorLogStore';
import MessageStore from './messageStore';
import SettingsStore from './settingsStore';
import CommonStore from './commonStore';
import CannedMessageStore from './cannedMessageStore';
import SendingEvents from '../../socket/socketEvents/sendingEvents';
import ReceivingEvents from '../../socket/socketEvents/receivingEvents';
import FeatureFlagStore from './featureFlagStore';
import CannedMessageTypeStore from './cannedMessageTypeStore';
import AutoReplyTypeStore from './autoReplyTypeStore';
import WorkTimeStore from './workTimeStore';
import AutoReplyV2Store from './autoReplyV2Store';

export class RootStore {
  constructor() {
    this.sendingEvents = new SendingEvents(this);
    this.receivingEvents = new ReceivingEvents(this);
    this.channelTypeStore = new ChannelTypeStore(this);
    this.contactTypeStore = new ContactTypeStore(this);
    this.messageTypeStore = new MessageTypeStore(this);
    this.smsDeliveryStatusStore = new SmsDeliveryStatusStore(this);
    this.pushNotificationTokenStore = new PushNotificationTokenStore(this);
    this.emailStore = new EmailStore(this);
    this.phoneNumberStore = new PhoneNumberStore(this);
    this.contactStore = new ContactStore(this);
    this.autoReplyTypeStore = new AutoReplyTypeStore(this);
    this.autoReplyStore = new AutoReplyStore(this);
    this.autoReplyV2Store = new AutoReplyV2Store(this);
    this.channelStore = new ChannelStore(this);
    this.errorLogStore = new ErrorLogStore(this);
    this.messageStore = new MessageStore(this);
    this.settingsStore = new SettingsStore(this);
    this.commonStore = new CommonStore(this);
    this.cannedMessageStore = new CannedMessageStore(this);
    this.featureFlagStore = new FeatureFlagStore(this);
    this.cannedMessageTypeStore = new CannedMessageTypeStore(this);
    this.workTimeStore = new WorkTimeStore(this);
  }
}

const rootStore = new RootStore();

export default rootStore;
